import type { ReactNode } from 'react';
import KoobTabsCompact from '@koob/ui/src/components/KoobTabsCompact';
import {
  useListMode,
  useSearchHotels,
  useSetListMode,
} from '../../hooks/useTripStoreSelectors';
import type { TripMapTranslate } from './types';

interface TripMapListProps {
  translation: TripMapTranslate;
  // The product list, drawn on the list tab.
  listSlot: ReactNode;
  // The map (`TripMap`), drawn on the map and itinerary tabs.
  children: ReactNode;
}

const TABS = [
  { id: 'list', key: 'compose.panel.list', icon: 'fa-light fa-list' },
  { id: 'map', key: 'compose.panel.map', icon: 'fa-light fa-map' },
  {
    id: 'itinerary',
    key: 'compose.panel.itinerary',
    icon: 'fa-light fa-compass',
  },
];

// The card on the right of the timeline: a title and tabs, then the product
// list, or the map on the map and itinerary tabs.
export default function TripMapList({
  translation: t,
  listSlot,
  children,
}: TripMapListProps) {
  const listMode = useListMode();
  const setListMode = useSetListMode();
  const searchHotels = useSearchHotels();
  const isList = listMode === 'list';
  const titleKey = isList
    ? searchHotels
      ? 'experiences:titleListHotel'
      : 'experiences:titleList'
    : searchHotels
      ? 'compose.panel.hotelsOnMap'
      : 'compose.panel.experiencesOnMap';

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border border-solid border-k-gray bg-white">
      <div className="flex shrink-0 items-center border-b border-solid border-gray-200 px-5 py-3">
        <h3 className="text-base font-semibold text-gray-900">{t(titleKey)}</h3>

        <div className="ml-auto">
          <KoobTabsCompact
            value={listMode}
            onValueChange={setListMode}
            tabs={TABS.map(({ id, key, icon }) => ({
              id,
              label: t(key),
              icon,
            }))}
          />
        </div>
      </div>

      {isList ? (
        <div className="min-h-0 flex-1 overflow-y-auto">{listSlot}</div>
      ) : (
        children
      )}
    </div>
  );
}
